import React from 'react';
import { services } from '../mockData';
import { Card, CardContent } from './ui/card';
import { Stethoscope } from 'lucide-react';

const gradientOverlays = [
  'from-cyan-600/90 to-blue-600/90',
  'from-purple-600/90 to-pink-600/90',
  'from-blue-600/90 to-indigo-600/90',
  'from-teal-600/90 to-emerald-600/90'
];

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-br from-cyan-50 via-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-transparent bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text font-bold text-sm uppercase tracking-wider">Our Services</span>
          <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-900 via-purple-800 to-blue-900 bg-clip-text text-transparent mt-2">Comprehensive Medical Care</h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto text-lg">
            From preventive care to chronic disease management, we offer a full range of medical services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <Card key={service.id} className="border-none shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 group">
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${gradientOverlays[index]} opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center`}>
                  <Stethoscope className="h-16 w-16 text-white animate-pulse" />
                </div>
              </div>
              <CardContent className="p-8 bg-gradient-to-br from-white to-gray-50">
                <h3 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-blue-900 bg-clip-text text-transparent mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;